import React from "react";
import Header from "../components/Header";
import MessagingUI from "../components/ServiceRequest/MessagingUI";
import ChatUsers from "../components/ServiceRequest/ChatUsers";

const ServiceRequest = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-5 lg:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />

      <div className="flex flex-col sm:flex-row md:space-x-5">
        <ChatUsers />
        <div className="w-full">
          <MessagingUI />
        </div>
      </div>
    </div>
  );
};

export default ServiceRequest;
